/** Hall editor fetches. RowConfig GET /rows is unused; inspector reads DatacenterConfig columns. */
export function editorLoadPaths(code: string, draftId: number | null): { draft?: string; racks: string } {
  const racks = `/api/datacenters/${code}/racks`
  if (draftId != null) return { draft: `/api/datacenters/${code}/drafts/${draftId}`, racks }
  return { racks }
}

export type DraftRackDiff = {
  deleted: Array<string | number>
  updated: Record<string, any>
  added: any[]
}

export function normalizeDraftRackDiff(value: unknown): DraftRackDiff | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null
  const source = value as Record<string, unknown>
  const nested = source.diff
  const diff = nested && typeof nested === 'object' && !Array.isArray(nested)
    ? nested as Record<string, unknown>
    : source
  return {
    deleted: Array.isArray(diff.deleted) ? diff.deleted.filter(item => typeof item === 'string' || typeof item === 'number') : [],
    updated: diff.updated && typeof diff.updated === 'object' && !Array.isArray(diff.updated)
      ? diff.updated as Record<string, any>
      : {},
    added: Array.isArray(diff.added) ? diff.added : [],
  }
}

/**
 * Wizard adds racks then save sets currentDraftId → loader can fetch a still-empty draft
 * and wipe the canvas. Skip applying that load while unsaved (!dbId) racks exist and
 * the incoming draft has nothing to offer.
 */
export function preserveUnsavedEditorRacks(
  storeRacks: Record<string, { dbId?: number | null }>,
  added: unknown[] | undefined,
  masterCount: number,
): boolean {
  const hasUnsaved = Object.values(storeRacks).some(r => r.dbId == null || r.dbId === undefined)
  if (!hasUnsaved) return false
  const addedLen = Array.isArray(added) ? added.length : 0
  if (addedLen > 0) return false
  // Empty draft + empty (or any) master must not clobber Wizard canvas before save lands.
  if (masterCount === 0) return true
  // Master exists but draft has no adds — applying master would drop unsaved Wizard racks.
  return true
}
